import { Box, Typography } from "@mui/material"
import { BoundEditableText } from "lib/@components/editable/editableText"
import { If } from "lib/@components/if"
import { useBoundValue } from "lib/@components/binding/use-bound-value"
import { useScheduleCodeAvailabilityCheck } from "../lib/use-schedule-code-availability-check"
import { useScheduleEditorIds } from "./hooks/use-schedule-editor-ids"
import { ScheduleCodeAvailabilityChanged } from "./schedule-editor-event-definitions.mjs"
import {
    isCodeUnavailable,
    resolveCodeDisplayError,
    shouldBlockCodeEnterKey,
    trimCode,
} from "./schedule-code-field-rules"

const CODE_FIELD = "code"

export function ScheduleCodeEditableField(props) {
    const { projectId, scheduleId, draftId } = useScheduleEditorIds()
    const [code, setCode] = useBoundValue(CODE_FIELD)
    const duplicateError = useScheduleCodeAvailabilityCheck({
        code,
        excludeScheduleId: scheduleId,
        projectId,
        onAvailabilityChange: notifyAvailabilityChanged,
    })
    const codeError = resolveCodeDisplayError({ code, duplicateError })

    return (
        <Box onKeyDown={blockEnterKey} onBlur={cleanUpCode}>
            <Typography variant="h5" component="h2" sx={{ color: "text.secondary" }}>
                <BoundEditableText field={CODE_FIELD} {...props} />
            </Typography>
            <If truthy={!!codeError}>
                <Typography variant="caption" color="error.main">
                    {codeError}
                </Typography>
            </If>
        </Box>
    )

    function notifyAvailabilityChanged(duplicateUnavailable) {
        ScheduleCodeAvailabilityChanged(draftId).raise({
            unavailable: isCodeUnavailable({ code, duplicateUnavailable }),
        })
    }

    function blockEnterKey(event) {
        if (shouldBlockCodeEnterKey({ key: event.key })) event.preventDefault()
    }

    function cleanUpCode() {
        const cleaned = trimCode(code)
        if (cleaned !== code) setCode(cleaned)
    }
}
